import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store";
import {GraphqlService} from "../../../../services/graphql.service";

import {NotificationService} from "../../../../services/notification.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";
import {
  CREATE_USER_ROLES_MUTATION,
  GET_SYSTEM_PERMISSIONS_QUERY,
  UPDATE_USER_ROLES_MUTATION
} from "../../../../store/entities/user-management/user-role/user-role.graphql";
import {
  SystemUserRole
} from "../../../../store/entities/system-configurations/temp-fcrs/system-user-role/system-user-role.model";
import { selectStoreItems } from '../../../../store/entities/store-item/store-item.selectors';
import { Observable } from 'rxjs';
import { uniqueId } from 'lodash';
import {GET_ALL_SYSTEM_PERMISSIONS} from "../system-roles-view/system-permissions";


@Component({
  selector: 'app-system-roles-add',
  templateUrl: './system-roles-add.component.html',
  styleUrl: './system-roles-add.component.scss'
})
export class SystemRolesAddComponent implements OnInit {


  @Output()
  onClose = new EventEmitter<any>()
  form: UntypedFormGroup;
  saveLoading: boolean;

  systemUserRole
  title: string
  permissions$: Observable<any> 
  // permissions



  constructor(
    private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    private apollo: GraphqlService,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<SystemRolesAddComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.systemUserRole = data?.systemUserRole
  }

  ngOnInit(): void {

    this.getPermissions()
    this.title = `${this.systemUserRole?.id ? 'Edit' : 'Add'} System User Role`

    this.form = this.fb.group({
      roleName: [this.systemUserRole?.roleName, Validators.required],
      rolePermissions: [this.systemUserRole?.rolePermissions],
      // roleDescription: [this.systemUserRole?.roleDescription, Validators.required],
    });
    if (this.systemUserRole?.id) {
      this.form.patchValue({
        roleName: this.systemUserRole.roleName,
        rolePermissions: this.systemUserRole.rolePermissions,
        // roleDescription: this.systemUserRole?.description
      })
    }

  }

  async getPermissions(){
    await this.store.dispatch(StoreItemActions.getStoreItems({
      entity:StoreItemEntity.permissions,
      query: GET_ALL_SYSTEM_PERMISSIONS,
      filtering: {}
    }))
    
    this.permissions$ =  this.store.select(selectStoreItems(StoreItemEntity.permissions))
    
  } 

  async submitForm(formValue: SystemUserRole) {
    const input = !this.systemUserRole?.id ? {...formValue, rolePermissions: []} : {
      ...formValue,
      uniqueId: this.systemUserRole?.uniqueId,
      rolePermissions: this.systemUserRole?.permissions?.map(p => p.uniqueId)
    };
    this.store.dispatch(StoreItemActions.createUpdateStoreItem({
      entity: StoreItemEntity.userRole,
      input,
      mutation: this.systemUserRole?.id ? UPDATE_USER_ROLES_MUTATION : CREATE_USER_ROLES_MUTATION,
      isInput: true
    }))
  }


  closeModal() {
    this.dialogRef.close()
  }

}


